import React from 'react'
import { Icon } from '@twilio/flex-webchat-ui'

export class AttachmentMessage extends React.Component {
  state = {
    loading: false
  }

  render () {
    const { loading } = this.state
    const { media } = this.props.message.source
    const size = this._mediaSize(media)
    const icon = this._mediaIcon(media)
    const classes = ['attachment-message']
    if (loading) {
      classes.push('attachment-message--loading')
    }
    return (
      <div
        className={classes.join(' ')}
        onClick={this._downloadMedia}
      >
        <div className="attachment-message__icon">
          <Icon icon={icon} />
        </div>
        <div className="attachment-message__info">
          <strong>{media.filename}</strong>
          &nbsp;
          <em>({size})</em>
        </div>
      </div>
    )
  }

  _mediaSize = media => {
    let bytes = media.size
    const si = true
    const dp = 1
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
    const units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    return bytes.toFixed(dp) + ' ' + units[u];
  }

  _mediaIcon = media => {
    const { contentType } = media
    if (contentType === 'application/pdf') {
      return 'Pdf'
    }
    if (contentType.startsWith('image/')) {
      return 'GenericImage'
    }
    return 'GenericDoc'
  }

  _downloadMedia = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true })
      const { message } = this.props
      const url = await message.source.media.getContentUrl()
      window.open(url)
      this.setState({ loading: false })
    }
  }
}
